import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import RichText from '~/components/common/rich-text';
import Icon from '~/components/common/icon';

/**
 * Render Rich Text (Fill in the blank, Assessment) Question Type
 *
 * @callback handleAnswerUpdate
 * @callback handleRichtextChange
 * @callback handleShowForm
 * @param {Object} props
 * @param {handleAnswerUpdate} props.handleAnswerUpdate
 * @param {handleRichtextChange} props.handleRichtextChange
 * @param {handleShowForm} props.handleShowForm
 * @param {string} props.questionType
 * @param {number} props.questionID
 * @param {string} props.answer
 * @param {boolean} props.updated
 * @param {boolean} props.showForm
 */
const QuestionTypeRichtext = ( {
	handleAnswerUpdate,
	handleRichtextChange,
	handleShowForm,
	questionType,
	questionID,
	answer,
	updated,
	showForm,
} ) => (
	<div className="ld-answer-editor">
		{ showForm ? (
			<Fragment>
				<div className="ld-answer-richtext-description">
					<RichText
						id={ `text-area-question-${ questionID }` }
						value={ answer }
						onChange={ handleRichtextChange }
					/>

					<div className="ld-answer-descriptions">
						{ LearnDashData.labels.questions_types_description[
							questionType
						] &&
							LearnDashData.labels.questions_types_description[
								questionType
							].map( ( description, i ) => (
								<p
									key={ `description-${ i }` }
									className="description"
									dangerouslySetInnerHTML={ {
										__html: description,
									} }
								/>
							) ) }
					</div>
				</div>

				<div className="ld-answer-editor-actions">
					<button
						className="is-button is-primary"
						onClick={ handleAnswerUpdate }
					>{ `${ LearnDashData.i18n.update_answer }` }</button>
					<span className="ld-trash">
						<button
							className="is-button components-button is-default"
							onClick={ handleShowForm }
						>{ `${ LearnDashData.i18n.cancel }` }</button>
					</span>
					{ updated && (
						<span className="ld-answer-updated">{ `${ LearnDashData.i18n.answer_updated }` }</span>
					) }
				</div>
			</Fragment>
		) : (
			<button
				className="ld-answer-read-only ld-button-reset"
				onClick={ handleShowForm }
			>
				<span>{ `${ LearnDashData.i18n.answer }` }</span>
				<div
					dangerouslySetInnerHTML={ {
						__html:
							'' === answer
								? `${ LearnDashData.i18n.edit_answer }`
								: answer,
					} }
				/>
				<Icon icon="pencil" />
				<span className="screen-reader-text">{ `${ LearnDashData.i18n.edit }` }</span>
			</button>
		) }
	</div>
);

/**
 * Valid props
 */
QuestionTypeRichtext.propTypes = {
	handleShowForm: PropTypes.func,
	handleAnswerUpdate: PropTypes.func,
	handleRichtextChange: PropTypes.func,
	questionType: PropTypes.string,
	questionID: PropTypes.number,
	answer: PropTypes.string,
	updated: PropTypes.bool,
	showForm: PropTypes.bool,
};

export default QuestionTypeRichtext;
